import type { FaireProductEntity } from "../../entity_types/product";

export const p_ehg9ec3zel: FaireProductEntity = {
  token: "p_ehg9ec3zel",
  type: "product",
  name: "LYMPHATIC CREAM | 9 OZ",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/8292314ebaa7c934031f93f91ca0de44830c703695760a7fa00714d80d462287.png",
  galleryImageUrls: [],
  priceDollars: 30.1,
  description:
    'Keeping your lymphatic system flowing is key to a healthy body and staying pain free. This all-natural lymphatic cream is formulated to stimulate lymph fluid drainage so our immune and circulatory systems can stay healthy and strong.\n\nTO USE: Apply to affected areas 1–2 times daily or as needed.\n\nINGREDIENTS: RAW SHEA BUTTER, ORGANIC SAFFLOWER OIL, ORGANIC ARROWROOT POWDER, 100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: FRANKINCENSE, GRAPEFRUIT, LEMON, LAVENDER, ORANGE, PEPPERMINT, GINGER, ROSEMARY, MYRRH, CYPRESS, GERANIUM, OREGANO.\n\n*Always check with your doctor before using a new product or supplement if you have any questions or concerns about how a product may affect your current health, medications, pregnancy, or breastfeeding.\n\n*This product may melt in transit with the hot summer weather. If you would rather not chance a melted product, our Lymphatic Lotion would be a great alternative!\n\nDimension: 9 oz, 2.857" x 3.46" x 2.857".',
  tags: [],
  msrpDollars: 43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:14.916Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
